import React from 'react';

import i18n from '../../i18n';
import { useTranslation } from "react-i18next";

import { VERSION } from '../../configurations/version.config'

import { useHistory} from 'react-router-dom';

import { Stack } from '@fluentui/react';
import { DefaultButton } from '@fluentui/react/lib/Button';
import '../../css/UserActions.css'
import { WEB_AUTH_URL } from '../../configurations/paths.config';
import { onGoToSG3PlusClick } from '../../common/Helpers';
import PropTypes from 'prop-types';
import Flag from './Flag';

const UserActions = (props) => {

    const { t } = useTranslation();
  
    const styleMenu = {
        root: { fontSize: '20px', marginRight: "15px", fontWeight: "bold" }
    }

    const flagEsUrl = 'ES';
    const flagEnUrl = 'EN';
    const history = useHistory();
    const { disabled = false, checked = false } = props;
    const stackTokens = { childrenGap: 40 };

    const handleItemClick = (id) => {
        return history.push("/profile", { userName: props.userName });
    }
    const handleChangeLanguage = (languaje) => {
      i18n.changeLanguage(languaje)
    }
    const handleLogout = () => {
        props.logOut(WEB_AUTH_URL);
    }

    let menuProps = {
        items: []
    };
    menuProps.items.push({
        key: 'profile',
        text: t('data-lang-topnavbar-profile'),
        iconProps: { iconName: 'UserOptional',  styles: styleMenu },
        className: "ms-Icon-custom",
        onClick: handleItemClick,
    });
    menuProps.items.push({
        key: 'edituser',
        text: t('data-lang-topnavbar-logout'),
        iconProps: { iconName: 'SignOut',  styles: styleMenu },
        className: "ms-Icon-custom",
        onClick: handleLogout,
    });
    menuProps.items.push({
        key: 'spanish',
        text: t('data-lang-lbl-spanish'),
        iconProps: { styles: styleMenu },
        className: "ms-Icon-custom",
        onClick: () => handleChangeLanguage("es"),
        onRenderIcon: () => {
            return <Flag inputParam_Code={flagEsUrl} />
        }
    });
    menuProps.items.push({
        key: 'english',
        text: t('data-lang-lbl-english'),
        iconProps: { styles: styleMenu },
        className: "ms-Icon-custom",
        onClick: () => handleChangeLanguage("en"),
        onRenderIcon: () => {
            return <Flag inputParam_Code={flagEnUrl} />
        }
    });
    
    menuProps.items.push({
        key: 'sg3book',
        text: t('data-lang-sg3plus'),
        className: "pb-3 ms-Icon-custom",
        iconProps: { iconName: 'Location',  styles: styleMenu },
        onClick: () => onGoToSG3PlusClick(),
    });

    menuProps.items.push({
        key: 'export',
        text: t('data-lang-lbl-export'),
        className: "pb-3 ms-Icon-custom",
        iconProps: { iconName: 'CloudDownload',  styles: styleMenu },
        onClick: () => props.exportAsImage(),
    });
    menuProps.items.push({
        key: 'version',
        text: t('data-lang-systemversion') + VERSION,
        iconProps: { iconName: 'Info',  styles: styleMenu },
        className: "border-top ms-Icon-custom",
    });


    return (
        <div className='user-action-dropdown'>
          <Stack horizontal wrap tokens={stackTokens}>
              <DefaultButton
                  text={props.userName}
                  iconProps={{ iconName: 'Settings' }}
                  primary
                  split
                  onClick={null}
                  menuProps={menuProps}
                  disabled={disabled}
                  checked={checked}
                  style={{border: "none", backgroundColor: "transparent"}}
              />
          </Stack>
        </div>
    )
}
UserActions.propTypes = {
    userName: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    logOut: PropTypes.func.isRequired,
    exportAsImage: PropTypes.func.isRequired,
};
export default UserActions